import { RollFilterType, TFabricRollFilter } from '@monorepo/types';
import { UiFilterModifiers } from '../ui-filter.modifier';
import { TFilterGroupModel } from '../ui-filter.types';

const fabricFilterToDisplayNameMap: Record<RollFilterType, string> = {
  ROLL_NO: 'All Roll No./Serial No.',
  STATUS: 'Status',
  GRN_STATUS: 'GRN Status',
  GRN_NUMBER: 'GRN No.',
};

export const FABRIC_FILTER_ROLL_LISTING_MODEL = {
  createModel: (items: TFabricRollFilter[], prevModel?: TFilterGroupModel<TFabricRollFilter>) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      return {
        type: 'SELECT_FILTER',
        key: item.filterType,
        displayName: fabricFilterToDisplayNameMap[item.filterType],
        items: item.values.map((val) => {
          return {
            value: val,
            isSelected: false,
          };
        }),
        selectedValues: [],
        virtualScroll: {
          itemSize: 40,
          minBufferPx: window.screen.height / 2,
          maxBufferPx: window.screen.height / 2,
        },
      };
    });
    return prevModel ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel) : createNewFilterModel;
  },
};
